import React, { FC } from 'react';
import { Download } from 'react-feather';
import ModalHeader from 'ts/common/components/gallery/ModalHeader';
import {
    getDownloadDestinationsTranslate,
    getMediaCountCaption
} from 'ts/common/components/gallery/helpers';

interface IDigitalDownloadRulesHeader {
    hasPin: boolean;
    isDownloadAlbum: boolean;
    isDownloadAll: boolean;
    isDownloadPhoto: boolean;
    isDownloadVideo: boolean;
    spFreeDigitals: SpAngularJs.ISpFreeDigitals;
    translateFilter: SpAngularJs.ITranslateFilter;
}

const DigitalDownloadRulesHeader: FC<IDigitalDownloadRulesHeader> = ({
    hasPin = false,
    isDownloadAlbum = false,
    isDownloadAll = false,
    isDownloadPhoto = false,
    isDownloadVideo = false,
    spFreeDigitals,
    translateFilter: t
}) => {
    const mediaCounts = spFreeDigitals.getPendingDownloadMediaCounts();

    const getHeaderText = () => {
        // A bulk download names what it contains, same as the single-rule destination modal.
        // Only all/album downloads carry counts, so the single-item branches below are untouched.
        if (mediaCounts) {
            const caption = getMediaCountCaption({
                ...mediaCounts,
                translate: getDownloadDestinationsTranslate(t)
            });

            if (caption) {
                return caption;
            }
        }

        if (isDownloadAlbum) {
            return t('downloadAlbumNoName');
        } else if (isDownloadAll) {
            return t('downloadAll');
        } else if (isDownloadVideo) {
            // This modal picks a digital rule, not the download itself.
            return t('selectDownloadOption');
        } else if (isDownloadPhoto) {
            return t('downloadPhoto');
        }

        return t('download');
    };

    return (
        <>
            {hasPin ? (
                <ModalHeader
                    modalIcon={Download}
                    headerText={getHeaderText()}
                    headerSubText={t('enterDownloadPin')}
                />
            ) : (
                <ModalHeader modalIcon={Download} headerText={getHeaderText()} />
            )}
        </>
    );
};

export default DigitalDownloadRulesHeader;
